/*
 * @Author: FengXiao
 * @Date: 2020-07-01 22:08:41
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-13 21:28:20
 */

import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
  },
  //一席国际版
  {
    path: '/yixi_international',
    name: 'International',
    meta: {
      keepAlive: false,
    },
    component: () => import('@/views/International.vue'),
  },
  // 演讲
  {
    path: '/speech',
    name: 'Speech',
    meta: {
      scrollToTop: true,
      initTop: true,
      keepAlive: false,
    },
    component: () => import('@/views/Speech.vue'),
  },
  // 演讲 专辑列表
  {
    path: '/speech/albums',
    name: 'SpeechAlbums',
    meta: {
      initTop: true,
      keepAlive: false,
    },
    component: () => import('@/views/SpeechAlbums.vue'),
  },
  // 演讲 专辑
  {
    path: '/speech/album/detail',
    name: 'SpeechAlbumDetail',
    meta: {
      initTop: true,
      keepAlive: false,
    },
    component: () => import('@/views/SpeechAlbumDetail.vue'),
  },
  // 演讲 详情
  {
    path: '/speech/detail',
    name: 'SpeechDetail',
    component: () => import('@/views/SpeechDetail.vue'),
    meta: {
      initTop: true,
      keepAlive: false,
    },
  },
  // 现场
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('@/views/Activity.vue'),
  },
  {
    path: '/activity/detail',
    name: 'ActivityDetail',
    component: () => import('@/views/ActivityDetail.vue'),
    meta: {
      initTop: true,
      keepAlive: false,
    },
  },
  // 活动
  {
    path: '/event',
    name: 'Event',
    component: () => import('@/views/Event/Event.vue'),
  },
  {
    path: '/event/detail',
    name: 'EventDetail',
    component: () => import('@/views/Event/EventDetail.vue'),
    meta: {
      initTop: true,
      keepAlive: false,
    },
  },
  {
    path: '/event/register',
    name: 'EventRegister',
    component: () => import('@/views/Event/EventRegister.vue'),
    meta: {
      initTop: true,
      keepAlive: false,
    },
  },
  // 万象
  {
    path: '/wanxiang',
    name: 'WanXiang',
    component: () => import('@/views/WanXiang.vue'),
    meta: {
      initTop: true,
      keepAlive: false,
    },
  },
  {
    path: '/wanxiang/detail',
    name: 'WanxiangDetail',
    component: () => import('@/views/WanXiangDetail.vue'),
    meta: {
      initTop: true,
      // keepAlive: false,
    },
  },
  // 枝桠
  {
    path: '/zhiya',
    name: 'ZhiYa',
    component: () => import('@/views/ZhiYa.vue'),
  },
  {
    path: '/zhiya/detail',
    name: 'ZhiYaDetail',
    component: () => import('@/views/ZhiYaDetail.vue'),
    meta: {
      initTop: true,
      keepAlive: false,
    },
  },
  // 记录
  {
    path: '/record',
    name: 'Record',
    component: () => import('@/views/Record.vue'),
  },
  // 资讯
  // {
  //   path: '/information',
  //   name: 'Information',
  //   component: () => import('@/views/Information.vue'),
  // },
  {
    path: '/record/detail',
    name: 'RecordDetail',
    component: () => import('@/views/RecordDetail.vue'),
    meta: {
      initTop: true,
      keepAlive: false,
    },
  },
  // 用户中心
  {
    path: '/userCenter',
    name: 'UserCenter',
    redirect: '/userCenter/vip_detail',
    component: () => import('@/views/UserCenter/index'),
    meta: {
      initTop: true,
    },
    children: [
      // 会员
      {
        path: 'vip_detail',
        name: 'UserCentervip_detail',
        component: () => import('@/views/UserCenter/vip_detail'),
      },

      // 订单
      {
        path: 'order',
        name: 'UserCenterOrder',
        component: () => import('@/views/UserCenter/order'),
      },
      // 收藏
      {
        path: 'collection',
        name: 'UserCenterCollection',
        component: () => import('@/views/UserCenter/collection'),
      },
      // 邀请与兑换
      {
        path: 'invitationAndExchange',
        name: 'UserCenterInvitationAndExchange',
        component: () => import('@/views/UserCenter/invitationAndExchange'),
      },
    ],
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About/index'),
    children: [
      { path: 'aboutYiXi', name: 'AboutYiXi', component: () => import('@/views/About/aboutYiXi') },
      { path: 'businessCooperation', name: 'BusinessCooperation', component: () => import('@/views/About/businessCooperation') },
      { path: 'copyright', name: 'copyright', component: () => import('@/views/About/copyright') },
      { path: 'userAgreement', name: 'UserAgreement', component: () => import('@/views/About/userAgreement') },
      { path: 'privacy', name: 'Privacy', component: () => import('@/views/About/privacy') },
      { path: 'memberHandbook', name: 'MemberHandbook', component: () => import('@/views/About/memberHandbook') },
      { path: 'continuityvip', name: 'Continuityvip', component: () => import('@/views/About/continuityvip') },
    ],
  },
  {
    path: '/privacyrule',
    name: 'privacyrule',
    component: () => import('@/views/privacyrule.vue'),
  },
  {
    path: '/middle',
    name: 'middle',
    component: () => import('@/views/Middle.vue'),
  },
  {
    path: '/pay/middle',
    name: 'PayMiddle',
    component: () => import('@/views/PayMiddle.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/articlepay',
    name: 'Articlepay',
    component: () => import('@/views/ArticlePay.vue'),
  },
  {
    path: '/bindmobile',
    name: 'Bindmobile',
    component: () => import('@/views/Bindmobile.vue'),
  },
  // 一席APP
  {
    path: '/yixiapp',
    name: 'YixiApp',
    component: () => import('@/views/YixiApp.vue'),
  },
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '*',
    redirect: '/home',
  },
];

const router = new VueRouter({
  routes,
});
window.$router = router;
export default router;

// 用以解决重复路由点击报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
